import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { datadogRum } from '@datadog/browser-rum';

import { middleware as analyticsMiddleware } from '@eb/site-analytics';
import { configureStore } from '@eb/redux-configure-store';

import { BasePage } from '../base';

import { getInitialData } from '../../redux/reducers/utils';
import reducer from '../../redux/reducers';

import { withCookieHeaderHeight, withStickyBehaviorSearch } from '../../hoc';
import {
    ConsumerHeader,
    getSearchPageHeaderOffset,
} from '../../components/ConsumerHeader';
import { isProd } from '../../utils/http';

import { CityBrowseBaseScreenContainer } from './containers';

import './BrowsePage.scss';
import '../app.scss';

const EnhancedSearchConsumerHeader = withStickyBehaviorSearch(ConsumerHeader);

class BrowsePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            headerOffset: getSearchPageHeaderOffset(props.cookieHeaderHeight),
        };

        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    componentDidMount() {
        const { cookieHeaderHeight, env } = this.props;

        if (isProd({ env })) {
            datadogRum.addRumGlobalContext('view.sub_app', 'browse');
        }

        this.setState({
            headerOffset: getSearchPageHeaderOffset(cookieHeaderHeight),
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.cookieHeaderHeight !== prevProps.cookieHeaderHeight) {
            this.setState({
                headerOffset: getSearchPageHeaderOffset(
                    this.props.cookieHeaderHeight,
                ),
            });
        }
    }

    render() {
        return (
            <Provider store={this._store}>
                <BasePage
                    {...this.props}
                    structureHeader={EnhancedSearchConsumerHeader}
                >
                    <div
                        className="feed-browse-page"
                        style={{ paddingTop: this.state.headerOffset }}
                    >
                        <CityBrowseBaseScreenContainer {...this.props} />
                    </div>
                </BasePage>
            </Provider>
        );
    }
}

export default withCookieHeaderHeight(BrowsePage);
